export default "__VITE_ASSET__NXK6hZn9IzZhMRlQttotEg__"